export default "__VITE_ASSET__BbflewRX__"